// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/fonts/MBCorpoSText-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/fonts/MBCorpoSTitle-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "MBCorpoSText-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}

@font-face {
  font-family: "MBCorpoSTitle-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
}

.App {
  text-align: center;
  font-family: "MBCorpoSText-Regular";
}
body {
  /* --background: none;
  background: #000 url("../public/assets/images/page-bg.png") 0 0;
  background-repeat: repeat-x;
  background-size: contain;
  display: flex;
    flex-direction: column;

  min-height: 100vh; */
}
.container {
  --background: none;
  /* background: #000 url("../public/assets/images/page-bg.png") 0 0; */
  background-repeat: repeat-x;
  background-size: contain;
  display: flex;
  flex-direction: column;
  /* height: 100vh;  */

  min-height: 100vh;
  /* font-family: "MBCorpoSText-Regular"; */
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}


@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,+DAAoE;AACtE;;AAEA;EACE,oCAAoC;EACpC,+DAAqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE;;;;;;;sBAOoB;AACtB;AACA;EACE,kBAAkB;EAClB,qEAAqE;EACrE,2BAA2B;EAC3B,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;;EAEpB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;;AAGA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@font-face {\n  font-family: \"MBCorpoSText-Regular\";\n  src: url(\"../src/fonts/MBCorpoSText-Regular.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"MBCorpoSTitle-Regular\";\n  src: url(\"../src/fonts/MBCorpoSTitle-Regular.otf\") format(\"opentype\");\n}\n\n.App {\n  text-align: center;\n  font-family: \"MBCorpoSText-Regular\";\n}\nbody {\n  /* --background: none;\n  background: #000 url(\"../public/assets/images/page-bg.png\") 0 0;\n  background-repeat: repeat-x;\n  background-size: contain;\n  display: flex;\n    flex-direction: column;\n\n  min-height: 100vh; */\n}\n.container {\n  --background: none;\n  /* background: #000 url(\"../public/assets/images/page-bg.png\") 0 0; */\n  background-repeat: repeat-x;\n  background-size: contain;\n  display: flex;\n  flex-direction: column;\n  /* height: 100vh;  */\n\n  min-height: 100vh;\n  /* font-family: \"MBCorpoSText-Regular\"; */\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
